import { useCallback, useEffect, useReducer, useRef } from "react";
import { useSelector } from "react-redux";
import Axios from "services/axios";

const MAINTENANCE_STATUS_URL = "/control/maintenance/status";
const POLL_INTERVAL = 60000;

const initialState = {
  isActive: false,
  maintenanceWindow: null,
  upcoming: null,
  bypassed: false,
  loading: true,
  error: null,
};

function maintenanceReducer(state, action) {
  switch (action.type) {
    case "LOADING":
      return { ...state, loading: true, error: null };
    case "SUCCESS":
      return {
        ...state,
        loading: false,
        isActive: action.payload.isActive,
        maintenanceWindow: action.payload.window || null,
        upcoming: action.payload.upcoming || null,
        bypassed: action.payload.bypassed || false,
        error: null,
      };
    case "ERROR":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}

export function useMaintenance() {
  const [state, dispatch] = useReducer(maintenanceReducer, initialState);
  const cancelRequest = useRef(false);
  const intervalRef = useRef(null);
  
  const userId = useSelector((state) => state?.user?.current?.details?.userId);

  const checkStatus = useCallback(async (isBackground = false) => {
    if (cancelRequest.current) return;
    
    if (!isBackground) {
      dispatch({ type: "LOADING" });
    }
    
    try {
      const params = userId ? { userId } : {};
      const { data } = await Axios.get(MAINTENANCE_STATUS_URL, { params });
      
      if (cancelRequest.current) return;
      
      dispatch({ type: "SUCCESS", payload: data?.data || data });
    } catch (error) {
      if (cancelRequest.current) return;
      dispatch({ type: "ERROR", payload: error.message });
    }
  }, [userId]);

  useEffect(() => {
    cancelRequest.current = false;
    
    checkStatus(false);
    
    intervalRef.current = setInterval(() => checkStatus(true), POLL_INTERVAL);
    
    return () => {
      cancelRequest.current = true;
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [checkStatus]);

  return {
    ...state,
    refetch: checkStatus,
  };
}

export default useMaintenance;
